$(function () {
    let $modal = $('#modal--verifyPhone');
    let $content = $modal.find('.modal-body');
    let $form = $modal.find('form');
    let $alert = $form.find('.alert-danger');
    let $original = $form;
    let $success = $content.find('.alert-success');

    $('.show-verify-phone').click(function (event) {
        const $link = $(this);
        const link = $link.attr('href');
        $.ajax(link).then(function (data) {
            if (data.result) {
                $original.removeClass('d-none');
                $success.addClass('d-none');
                $alert.removeClass('d-none').html(data.message);
            } else {
                $modal.modal('show');
                $success.addClass('d-none');
                $original.removeClass('d-none');
                $content.slideDown('fast');
            }
        });
        event.preventDefault();
    });

    $modal.on('hide.bs.modal', function (event) {
        $alert.addClass('d-none').text('');
    });

    $form.submit(function (event) {
        event.preventDefault();

        const url = $form.attr('action');
        const data = $form.serializeArray();
        data.push({name: 'ajaxRequest', value: true});
        $.ajax({method: 'post', url: url, data: data, xhrFields: {withCredentials: true}})
            .then(function (data) {
                if (data.result) {
                    $original.removeClass('d-none');
                    $success.addClass('d-none');
                    $alert.html(data.message);
                } else {
                    $original.addClass('d-none');
                    $success.removeClass('d-none');
                }
            })
            .fail(function () {
                $original.removeClass('d-none');
                $success.addClass('d-none');
                $alert.removeClass('d-none').html('Unknown error');
            });
    });
});
